import { TablesInputProvider, useTablesInput } from 'providers/TablesInputProvider';
import TablesScreen from 'screens/TablesScreen';
import { HeroPage } from 'config/hero-covers';
import useOfflineQuery from 'hooks/useOfflineQuery';
import { usePaymentsQuery } from 'generated/graphql';

const PaymentsInner = () => {
  const { input, profileID, isQueryPaused } = useTablesInput();
  const [result, refetch] = useOfflineQuery('payments-query', usePaymentsQuery, {
    variables: { input, profileID },
    pause: isQueryPaused,
    returnCachedDataWhileFetching: true,
  });
  return <TablesScreen heroPage={HeroPage.Payments} result={result} refetch={refetch} dataKey="shipmentsHistory" />;
};

const Payments = () => (
  <TablesInputProvider>
    <PaymentsInner />
  </TablesInputProvider>
);

export default Payments;
